module.exports = __webpack_public_path__ + "static/img/bg-image.eb5c7d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg-image.jpg
// module id = v6WR
// module chunks = 1